import React, { SetStateAction, useContext, useEffect, useState } from "react";
import ClientContext from "../context/ClientContext";
import FormContext from "../context/FormContext";

import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";

import { Container } from "react-bootstrap";
import Styles from "../styles.module.scss";
import { FormType } from "../types/Types";

import { clientsInfo } from "../utils/clientsInfo";

export const FirstForm: () => JSX.Element = () => {
  const history = useHistory();
  const { setFormData } = useContext(FormContext);
  const { client, setClient } = useContext(ClientContext);
  const [selected, setSelected] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm<FormType>();

  const handleClient1 = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setSelected(true);
    setClient("Client 1");
  };

  const handleClient2 = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setClient("Client 2");
  };

  const handleNewClient = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setValue("projectName", "");
    setValue("projectDescription", "");
    setValue("projectIsNew", "");
    setValue("projectLevel", "");
    setSelected(false);
    setClient("");
  };

  useEffect(() => {
    if (client === "Client 1") {
      setSelected(true);
      setValue("projectName", clientsInfo.client1.projectName);
      setValue("projectDescription", clientsInfo.client1.projectDescription);
      setValue("projectIsNew", "No");
      setValue("projectLevel", "High");
    }
    if (client === "Client 2") {
      setSelected(true);
      setValue("projectName", clientsInfo.client2.projectName);
      setValue("projectDescription", clientsInfo.client2.projectDescription);
      setValue("projectIsNew", "No");
      setValue("projectLevel", "High");
    }
  }, [client]);

  const submitVoid = (data: SetStateAction<FormType>) => {
    if (
      !errors.projectName &&
      !errors.projectDescription &&
      !errors.projectIsNew &&
      !errors.projectLevel
    ) {
      setFormData(data);
      history.push("/example/forms-challenge/second");
    }
  };

  return (
    <Container className={Styles.mainContainer}>
      <h1 className='text-center mb-5'>Motor de rentabilidad</h1>

      <form onSubmit={handleSubmit(submitVoid)} autoComplete='off'>
        <div className={Styles.buttonsDiv}>
          <button className={Styles.formButton} onClick={handleClient1}>
            Cliente 1
          </button>
          <button className={Styles.formButton} onClick={handleClient2}>
            Cliente 2
          </button>
          <button className={Styles.formButton} onClick={handleNewClient}>
            Nuevo Cliente
          </button>
        </div>

        <p className='mt-3 font-weight-bold'>Nombre del proyecto</p>
        <input
          type='text'
          className={Styles.formTextInput}
          placeholder='Nombre del proyecto '
          {...register("projectName", { required: true, maxLength: 80 })}
          disabled={selected ? true : false}
        />
        {errors.projectName?.type === "required" && (
          <p className={Styles.errorP}>Nombre del proyecto requerido</p>
        )}

        <p className='mt-3 font-weight-bold'>Descripcion del prouyecto</p>
        <input
          type='text'
          className={Styles.formTextInput}
          placeholder='Descripcion del proyecto '
          {...register("projectDescription", {
            required: true
          })}
          disabled={selected ? true : false}
        />
        {errors.projectDescription?.type === "required" && (
          <p className={Styles.errorP}>Descripcion del proyecto requerida</p>
        )}

        <p className='mt-3 font-weight-bold'>Es un proyecto nuevo?</p>
        <div className={Styles.miniContainer}>
          <label htmlFor='isNew'>
            Si, quieron empezar de cero{" "}
            <input
              {...register("projectIsNew", { required: true })}
              type='radio'
              value='Yes'
              name='isProjectNew'
              disabled={selected ? true : false}
            />
          </label>

          <label htmlFor='isNew'>
            No, es una implementacion{" "}
            <input
              {...register("projectIsNew", { required: true })}
              type='radio'
              value='No'
              name='isProjectNew'
            />
          </label>
          {errors.projectIsNew?.type === "required" && (
            <p className={Styles.errorP}>Seleccione algun estado</p>
          )}
        </div>

        <p className='mt-3 font-weight-bold'>Nivel de importancia</p>
        <div className={Styles.miniContainer}>
          <label htmlFor='isNew'>
            Alta
            <input
              {...register("projectLevel", { required: true })}
              type='radio'
              value='High'
              name='projectLevel'
            />
          </label>

          <label htmlFor='isNew'>
            Media
            <input
              {...register("projectLevel", { required: true })}
              type='radio'
              value='Medium'
              name='projectLevel'
              disabled={selected ? true : false}
            />
          </label>

          <label htmlFor='isNew'>
            Baja
            <input
              {...register("projectLevel", { required: true })}
              type='radio'
              value='Low'
              name='projectLevel'
              disabled={selected ? true : false}
            />
          </label>
          {errors.projectLevel?.type === "required" && (
            <p className={Styles.errorP}>Seleccione algun nivel</p>
          )}
        </div>

        <input type='submit' className={Styles.submitButton} />
      </form>
    </Container>
  );
};
